import React from "react"
import ReactApexChart from "react-apexcharts"

import KpiCard from "../parts/KpiCard"
import MetricHint from "../parts/MetricHint"
import {
	Card, EmptyNote, baseChartOptions, CHART_COLORS,
	formatNumber, formatPercent, mutedStyle,
} from "../parts/common"

/** Продукт: чем пользуются, как быстро начинают работать, на чём сидят кассы. */
function Product({ data }) {
	const modules = data.modules || []
	const activation = data.activation || {}
	const versions = data.versions || []
	const activePoints = data.active_points || 0

	const versionsChart = {
		options: {
			...baseChartOptions,
			chart: { ...baseChartOptions.chart, type: "donut", height: 320 },
			colors: CHART_COLORS,
			labels: versions.map((row) => row.version),
			legend: { position: "bottom", fontSize: "12px" },
			dataLabels: { enabled: true, formatter: (value) => Math.round(value) + "%" },
		},
		series: versions.map((row) => row.points),
	}

	const started = (activation.points || 0) - (activation.never_started || 0)

	return (
		<>
			<div className="row g-2 mb-3">
				{modules.map((module) => (
					<div className="col-md-3" key={module.key}>
						<KpiCard title={module.label} hintKey="metric_adoption_hint"
							value={formatPercent(module.percent)}
							sublabel={`${formatNumber(module.count)} из ${formatNumber(activePoints)} точек`} />
					</div>
				))}
				<div className="col-md-3">
					<KpiCard title="Активация" hintKey="metric_activation_hint"
						value={activation.avg_days ? `${activation.avg_days} дн.` : "—"}
						sublabel="от подключения до первого чека" accent="#f0a04c" />
				</div>
			</div>

			<div className="row g-2">
				<div className="col-md-6">
					<Card title="Как начинают работать" hint={<MetricHint hintKey="metric_activation_hint" />}>
						{(activation.points || 0) === 0 && <EmptyNote>За период не было новых подключений</EmptyNote>}
						{(activation.points || 0) > 0 && (
							<table className="table table-sm table-bordered mb-0" style={{ fontSize: "13px" }}>
								<tbody>
									<tr>
										<td>Подключено точек за период</td>
										<td className="text-end"><b>{formatNumber(activation.points)}</b></td>
									</tr>
									<tr>
										<td>Пробили первый чек за 3 дня</td>
										<td className="text-end">
											{formatNumber(activation.in_3_days)}
											<span style={mutedStyle}> · {formatPercent((activation.in_3_days / activation.points) * 100)}</span>
										</td>
									</tr>
									<tr>
										<td>Пробили первый чек за 14 дней</td>
										<td className="text-end">
											{formatNumber(activation.in_14_days)}
											<span style={mutedStyle}> · {formatPercent((activation.in_14_days / activation.points) * 100)}</span>
										</td>
									</tr>
									<tr>
										<td>Так и не начали работать</td>
										<td className="text-end" style={{ color: "var(--dark-fg-danger, #d23434)" }}>
											{formatNumber(activation.never_started)}
											<span style={mutedStyle}> · {formatPercent((activation.never_started / activation.points) * 100)}</span>
										</td>
									</tr>
									<tr>
										<td>Начали работать</td>
										<td className="text-end" style={{ color: "var(--dark-fg-success, #1f9d57)" }}>{formatNumber(started)}</td>
									</tr>
								</tbody>
							</table>
						)}
						<div style={{ ...mutedStyle, marginTop: "8px" }}>
							Точка, не пробившая чек за две недели, почти всегда уходит — это самый ранний
							сигнал оттока, какой есть в данных.
						</div>
					</Card>
				</div>

				<div className="col-md-6">
					<Card title="Версии кассы">
						{versions.length === 0 && <EmptyNote>Нет данных</EmptyNote>}
						{versions.length > 0 && (
							<ReactApexChart options={versionsChart.options} series={versionsChart.series}
								type="donut" height={320} />
						)}
					</Card>
				</div>
			</div>
		</>
	)
}

export default Product
